module.exports = "varying vec4 mvPosition;\nvarying vec3 worldNormal;\nvarying vec3 cameraToVertex;\nvarying vec2 vUv;\nvarying vec3 mPosition;\nvarying vec3 wPosition;\n\nvoid main() {\n  mPosition = position;\n  mvPosition = modelViewMatrix * vec4( position, 1.0 );\n  worldNormal = normalMatrix * normal;\n  wPosition = (modelMatrix * vec4( position, 1.0 )).xyz;\n  cameraToVertex = wPosition - cameraPosition;\n  vUv = uv;\n  gl_Position = projectionMatrix * mvPosition;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/simple_texture.vs
// module id = 176
// module chunks = 5